import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'svc-create-workorder-confirmation',
  templateUrl: './create-workorder-confirmation.component.html',
  styleUrls: ['./create-workorder-confirmation.component.css'],
})
export class CreateWorkorderConfirmationComponent implements OnInit {
  workOrderId: number;
  customerName: string;
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.workOrderId = this.activatedRoute.snapshot.queryParams.workOrderId;
    this.customerName = this.activatedRoute.snapshot.queryParams.customerName;
  }
}
